import {connect, useDispatch} from "react-redux";
import React, {useEffect, useState} from "react";
import {change, Field, formValueSelector, InjectedFormProps, reduxForm} from "redux-form";
import * as ReactBootstrap from "react-bootstrap";
import SlidingPane from "react-sliding-pane";
import {FormButtons, ICONS, renderers, validations} from "../../../components";
import {coverageOptions, pricingOptions, reproducibilityOptions} from "./constants";
import {GSXPart, PartDataTable} from "../../../GSXComponents";
import {TicketPrint} from "../../../api";
import { GSXService } from "../../../services";
import {showErrorToast} from "../../../state/toasts";

const FORM_NAME = 'part-request-form'
type PartRequestFormHTMLProps = {
    ticket?:TicketPrint
    selectedComponentCode?:string
    isIntangiblePart?:boolean
    isQuote?:boolean
}
type GSXComponentIssue =InjectedFormProps & {
    code:string
    description:string
    componentCode:string
    componentDescription:string
    issues:Array<{
          code:string
          description:string
    }>
}

let PartRequestFormHTML: React.FC<PartRequestFormHTMLProps & InjectedFormProps<{}, PartRequestFormHTMLProps>> = ({
  ticket,
  handleSubmit,
  pristine,
  reset,
  submitting,
  selectedComponentCode,
  isIntangiblePart,
  isQuote
}) => {
  const dispatch = useDispatch()
  const [componentIssuesOptions, setComponentIssuesOptions] = useState<Array<GSXComponentIssue>>()
  const [isPaneOpen, setIsPaneOpen] = useState<boolean>(false)
  const getComponentIssueOptions = (identifier:string) => {
    const data = {
      data: {
        device: {
          id: identifier,
        },
      },
    }
    new GSXService()
      .repair_product_componentissue(data)
      .then((response: { componentIssues: React.SetStateAction<GSXComponentIssue[] | undefined>; }) => {
        setComponentIssuesOptions(response.componentIssues)
      })
      .catch((errors: any) => {
        setComponentIssuesOptions([])
        console.error(errors)
        showErrorToast("Error","Could not fetch Component Issue Options.")
      })
  }

  const handlePartSelection = (part:GSXPart) => {
    dispatch(change(FORM_NAME, 'description', part.description))
    dispatch(change(FORM_NAME, 'part_number', part.number))
    dispatch(change(FORM_NAME, 'is_quote', part.typeDescription==="Billing"?true:false))
    setIsPaneOpen(false)
  }
  useEffect(() => {
    ticket?.device?.identifier && getComponentIssueOptions(ticket?.device?.identifier)
  }, [])
  return (
    <form onSubmit={handleSubmit}>
      <ReactBootstrap.Col xs="12">
        <Field
          name="description"
          label="Description"
          validate={[validations.required]}
          component={renderers.renderField}
          type="text"
        />
        {/*TODO: This Should use Existing Slider*/}
        <SlidingPane
          isOpen={isPaneOpen}
          title="Select the Part"
          overlayClassName="on-top"
          onRequestClose={() => {
            // triggered on "<" on left top click or on outside click
            setIsPaneOpen(false)
          }}
        >
            {ticket?.device?.identifier && <PartDataTable
            onSelection={(item) => handlePartSelection(item)}
            device_identifier={ticket.device.identifier}
          />}
        </SlidingPane>
        <div className="text-end">
          <ReactBootstrap.Button
            onClick={() => setIsPaneOpen(true)}
            variant={'dark'}
            size={'sm'}
          >
            {ICONS.SEARCH} Parts
          </ReactBootstrap.Button>
        </div>
      </ReactBootstrap.Col>

      <ReactBootstrap.Col xs="12">
        <Field
          name="part_number"
          label="Part Number"
          validate={!isIntangiblePart && !isQuote &&  [validations.required]}
          component={renderers.renderField}
          type="text"
        />
      </ReactBootstrap.Col>

      <ReactBootstrap.Col xs={12}>
        <Field
          name="reproducibility"
          label="Reproducibility"
          validate={!isIntangiblePart && !isQuote &&[validations.required]}
          component={renderers.renderSelectField}
          as="select"
        >
          {reproducibilityOptions &&
            reproducibilityOptions.map((c) => {
              return (
                <option key={c.code} value={c.code}>
                  {c.description}
                </option>
              )
            })}
        </Field>
      </ReactBootstrap.Col>

      <ReactBootstrap.Col xs="12">
        <Field
          component={renderers.renderSelectField}
          as="select"
          validate={!isIntangiblePart && !isQuote &&[validations.required]}
          name="coverage_option"
          label="Coverage Option"
        >
          {coverageOptions.map((state) => {
            return (
              <option key={state} value={state}>
                {state}
              </option>
            )
          })}
        </Field>
      </ReactBootstrap.Col>
      <ReactBootstrap.Col xs={12}>
        <Field
          component={renderers.renderSelectField}
          as="select"
          validate={!isIntangiblePart && !isQuote && [validations.required]}
          name="component_code"
          label="Component Code"
        >
          {componentIssuesOptions &&
            componentIssuesOptions.map((state) => {
              return (
                <option key={state.componentCode} value={state.componentCode}>
                  {state.componentDescription}
                </option>
              )
            })}
        </Field>
      </ReactBootstrap.Col>
      <ReactBootstrap.Col xs={12}>
        <Field
          name="issue_code"
          label="Issue Code"
          validate={!isIntangiblePart && !isQuote && [validations.required]}
          component={renderers.renderSelectField}
          as="select"
        >
          {selectedComponentCode &&
            componentIssuesOptions &&
            componentIssuesOptions.map &&
            componentIssuesOptions
              .filter((x) => x.componentCode === selectedComponentCode)[0]
              .issues.map((c) => {
                return (
                  <option key={c.code} value={c.code}>
                    {c.description}
                  </option>
                )
              })}
        </Field>
      </ReactBootstrap.Col>
       <ReactBootstrap.Col xs="12">
        <Field
          component={renderers.renderSelectField}
          as="select"
          name="pricing_option"
          label="Pricing Option"
        >
          {pricingOptions.map((state) => {
            return (
              <option key={state} value={state}>
                {state}
              </option>
            )
          })}
        </Field>
      </ReactBootstrap.Col>


      <ReactBootstrap.Col  className={"mt-2"} xs={12}>
        <label className={"me-2"} htmlFor="from_consigned_stock">Is From Consigned Stock?</label>

        <Field
          name="from_consigned_stock"
          id={`from_consigned_stock`}
          component="input"
          type="checkbox"
        />
      </ReactBootstrap.Col>


      <ReactBootstrap.Col className={"mt-2"} xs={12}>
        <label className={"me-2"} htmlFor="is_intangible_part">Is Intangible Part</label>

        <Field
          name="is_intangible_part"
          id={`is_intangible_part`}
          component="input"
          type="checkbox"
        />
      </ReactBootstrap.Col>

         <ReactBootstrap.Col className={"mt-2"} xs={12}>
        <label className={"me-2"}  htmlFor="is_quote">Is Quote</label>

        <Field
          name="is_quote"
          id={`is_quote`}
          component="input"
          type="checkbox"
          checked={isQuote}
        />
      </ReactBootstrap.Col>

      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}
let PartRequestFormRaw = reduxForm({
  form: FORM_NAME,
})(PartRequestFormHTML)

const selector = formValueSelector(FORM_NAME)
export const PartRequestForm = connect((state) => {
  const selectedComponentCode = selector(state, 'component_code')
  const isIntangiblePart = selector(state, 'is_intangible_part')
  const isQuote = selector(state, 'is_quote')

  return {
    selectedComponentCode,
    isIntangiblePart,
    isQuote
  }
})(PartRequestFormRaw)
